import React, { useContext } from 'react';

import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';

import { ContextSolicitacoes } from '../../../services/solicitacoes';

import NovaSolicitacaoLayout from './Layout';
import { ContextSindico } from '../../../services/sindico';

const NovaSolicitacao = ({ isSindico }) => {
  const { tema } = useContext(
    isSindico ? ContextSindico : ContextoListaApartamentos
  );

  const {
    getTipoSolicitacoes,
    getVerificaAgendamento,
    getPeriodoAgente,
    loadApontamentos,
    getSolicitacoes,
    getSolicitacaoUnica,
    loadingSolicitacaoSelecionada,
    loadImoveisDisponiveis,
    setImovelSolicitacao,
    imovelSolicitacao,
    listaDeImoveis,
    loadingImoveis,
  } = useContext(isSindico ? ContextSindico : ContextSolicitacoes);

  return (
    <NovaSolicitacaoLayout
      getTipoSolicitacoes={getTipoSolicitacoes}
      getVerificaAgendamento={getVerificaAgendamento}
      getPeriodoAgente={getPeriodoAgente}
      loadApontamentos={loadApontamentos}
      getSolicitacoes={getSolicitacoes}
      getSolicitacaoUnica={getSolicitacaoUnica}
      loadingSolicitacaoSelecionada={loadingSolicitacaoSelecionada}
      tema={tema}
      loadImoveisDisponiveis={loadImoveisDisponiveis}
      listaDeImoveis={listaDeImoveis}
      setImovelSolicitacao={setImovelSolicitacao}
      imovelSolicitacao={imovelSolicitacao}
      loadingImoveis={loadingImoveis}
      redirectPath={'/solicitacoes'}
      isSindico={isSindico}
    />
  );
};

export default NovaSolicitacao;
